import * as React from 'react';

import { CustomIconProps, defaultIconProps } from './types';

export function DeleteIcon({
  size = defaultIconProps.size,
  color = '#FF383C',
  className,
  ...props
}: CustomIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5.25a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 5.25zM7.5 2.25a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 4.5a.75.75 0 01.75.75V19.5h12V5.25a.75.75 0 011.5 0V19.5A1.5 1.5 0 0118 21H6a1.5 1.5 0 01-1.5-1.5V5.25a.75.75 0 01.75-.75z"
        fill={color}
      />
    </svg>
  );
}

export default DeleteIcon;
